// frontend/src/components/plot/charts/StandardLineChart.js
import React, { useMemo } from 'react';
import { ResponsiveContainer, ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Brush } from 'recharts';
import { getLighterColor } from '../../../utils/colorUtils';
import CustomTooltip from './CustomTooltip';
import { getFilteredChartData, formatXAxisTick, getYAxisDomain } from './chartUtils';

export default function StandardLineChart({ metric, chartData, visibleDevices, forecastVisible = true, localTimeEnabled = true }) {
  const filteredData = useMemo(() => getFilteredChartData(chartData, forecastVisible), [chartData, forecastVisible]);

  return (
    <div style={{ marginBottom: '20px' }}>
      <h5 style={{ margin: '0 0 8px 0', color: '#334155' }}>{metric.label}</h5>
      <div style={{ width: '100%', height: '280px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <ComposedChart data={filteredData}>
            <CartesianGrid strokeDasharray="2 2" stroke="#f1f5f9" />
            <XAxis
              dataKey="timestamp"
              type="number"
              scale="time"
              domain={['dataMin', 'dataMax']}
              tickFormatter={(ts) => formatXAxisTick(ts, localTimeEnabled)}
              minTickGap={30}
              tick={{ fontSize: 10 }}
            />
            <YAxis
              tick={{ fontSize: 10 }}
              domain={getYAxisDomain(metric.type)}
              unit={metric.unit ? ` ${metric.unit}` : undefined}
            />
            <Tooltip content={<CustomTooltip localTimeEnabled={localTimeEnabled} />} />
            <Brush dataKey="time" height={24} stroke="#94a3b8" fill="#f8fafc" />

            {visibleDevices.map((dev) => {
              const fcstColor = getLighterColor(dev.color, 40);
              return (
                <React.Fragment key={dev.id}>
                  <Line
                    type="monotone"
                    dataKey={`${metric.type}_${dev.id}_hist`}
                    name={`${metric.label}\n(${dev.name})`}
                    stroke={dev.color}
                    strokeWidth={2}
                    dot={{ r: 3, shape: 'circle' }}
                    connectNulls={true}
                  />
                  {forecastVisible && (
                    <Line
                      type="monotone"
                      dataKey={`${metric.type}_${dev.id}_fcst`}
                      name={`${metric.label} forecast\n(${dev.name})`}
                      stroke={fcstColor}
                      strokeWidth={2}
                      dot={{ r: 3, shape: 'diamond' }}
                      connectNulls={true}
                    />
                  )}
                </React.Fragment>
              );
            })}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
